import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
// import i18n from '@/lang' // Internationalization
// import settings from './settings'
NProgress.configure({
  showSpinner: false
});
const whiteList = ['/login', '/auth-redirect'];
// const getPageTitle = (key: string) => {
//   const hasKey = i18n.te(`route.${key}`)
//   if (hasKey) {
//     const pageName = i18n.t(`route.${key}`)
//     return `${pageName} - ${settings.title}`
//   }
//   return `${settings.title}`
// }
router.beforeEach(async (to, from, next) => {
  // Start progress bar
  NProgress.start();
  // Determine whether the user has logged in
  // Has no token
  if (whiteList.indexOf(to.path) !== -1) {
    // In the free login whitelist, go directly
    next();
  } else {
    // Other pages that do not have permission to access are redirected to the login page.
    // next(`/login?redirect=${to.path}`)
    // NProgress.done()
    next();
  }
});
router.afterEach(() => {
  // Finish progress bar
  NProgress.done();
  // set page title
  // document.title = getPageTitle(to.meta.title)
});